import React, { useEffect, useState } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { AdminButton } from "../../../components/buttons/versionHistoryBtn";
import back from "../../../assets/back.svg";
import "../customers.css";
import { useDispatch } from "react-redux";
import { subscriberRequestPharmacyDetail } from "../../../redux/actions/customerActions";
import ErrorPopup from "../../../components/popups/ErrorPopup";
import LoadingSpinnerTable from "../../../components/utilites/loader";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";
import UpdateToExecutiveModal from "../../../components/modals/Customer/updateToExecutiveModal";
import eye from "../../../assets/view-eye.svg";
import { pdfChecker } from "../../../components/utilites/helper";
import ImageViewModal from "../../../components/modals/ImageViewModal";
import PdfView from "../../../components/modals/PdfView";
import TableContainer from "../../../components/layouts/table-container/table-container";
import moment from "moment";

const SubscribeRequestPharmacyView = () => {
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
  const [subscribeReqData, setSubscribeReqData] = useState(null);
  const [approveShow, setApproveShow] = useState(false);
  const [fullDataShow, setFullDataShow] = useState([]);
  const [userType, setuserType] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [imageModal, setImageModal] = useState(false);
  const [imageTitleData, setImageTitleData] = useState("");
  const [imageUrlData, setImageUrlData] = useState("");
  const [openPdf, setOpenPdf] = useState(false);
  const [pdfFileUrl, setPdfFileUrl] = useState(null);
  const [filename, setFileName] = useState(null);

  useEffect(() => {
    setLoading(true);
    dispatch(subscriberRequestPharmacyDetail(params?.id, onSuccess, onError));
  }, []);

  const onSuccess = (data) => {
    setLoading(false);
    setFullDataShow(data?.data?.data);
    setSubscribeReqData(data.data.data);
    setuserType("pharmacy");
  };
  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onError = (err) => {
    setLoading(false);
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  console.log(userType);

  const docBasicDetails = [
    {
      heading: "Jivini’s Customer Code",
      title: subscribeReqData?.code ? subscribeReqData?.code : "--",
    },
    {
      heading: "Doctor Name",
      title: subscribeReqData?.name
        ? `DR. ${subscribeReqData?.name.toUpperCase()}`
        : "--",
    },
    {
      heading: "Pharmacy Type",
      title: subscribeReqData?.pharmacy_type
        ? subscribeReqData?.pharmacy_type.charAt(0).toUpperCase() +
          subscribeReqData?.pharmacy_type.slice(1)
        : "--",
    },
    {
      heading: "Qualification",
      title: subscribeReqData?.qualification
        ? subscribeReqData?.qualification
        : "--",
    },
    {
      heading: "Specialization",
      title: subscribeReqData?.specialization?.name
        ? subscribeReqData?.specialization?.name
        : "--",
    },
    {
      heading: "MCI Number",
      title: subscribeReqData?.medical_council_registration_number
        ? subscribeReqData?.medical_council_registration_number
        : "--",
    },
  ];

  const pharmacyBasicDetails = [
    {
      heading: "Jivini’s Customer Code",
      title: subscribeReqData?.code ? subscribeReqData?.code : "--",
    },
    {
      heading: "Pharmacy Name",
      title: subscribeReqData?.pharmacy_name
        ? subscribeReqData?.pharmacy_name.toUpperCase()
        : "--",
    },
    {
      heading: "Drug License Number - 20A",
      title: subscribeReqData?.drug_licence_number_20_a
        ? subscribeReqData?.drug_licence_number_20_a
        : "--",
    },
    {
      heading: "Drug License Number - 20B",
      title: subscribeReqData?.drug_licence_number_20_b
        ? subscribeReqData?.drug_licence_number_20_b
        : "--",
    },
    {
      heading: "GST Number",
      title: subscribeReqData?.gst_number ? subscribeReqData?.gst_number : "--",
    },
  ];

  const contactDetails = [
    {
      heading: "Mobile Number",
      title: `+91 ${subscribeReqData?.mobile}`
        ? `+91 ${subscribeReqData?.mobile}`
        : "--",
    },
    {
      heading: "Alternate Mobile Number",
      title: `+91 ${subscribeReqData?.alternate_mobile}`
        ? `+91 ${subscribeReqData?.alternate_mobile}`
        : "--",
    },
    {
      heading: "Email Address",
      title: subscribeReqData?.email ? subscribeReqData?.email : "--",
    },
    {
      heading: "Address",
      title:
        subscribeReqData?.address &&
        `${subscribeReqData?.address?.address_one}, ${subscribeReqData?.address?.address_two}, ${subscribeReqData?.address?.address_three}`,
    },
    {
      heading: "Landmark",
      title: subscribeReqData?.address?.landmark
        ? subscribeReqData?.address?.landmark
        : "--",
    },
    {
      heading: "State",
      title: subscribeReqData?.state?.name
        ? subscribeReqData?.state?.name
        : "--",
    },
    {
      heading: "District",
      title: subscribeReqData?.district?.name
        ? subscribeReqData?.district?.name
        : "--",
    },
    {
      heading: "City",
      title: subscribeReqData?.city?.name ? subscribeReqData?.city?.name : "--",
    },
    {
      heading: "Pincode",
      title: subscribeReqData?.pincode ? subscribeReqData?.pincode : "--",
    },
  ];

  const routes = [
    { path: "/", breadcrumb: "Admin" },
    {
      path: "/customers/onboarding-pharmacy",
      breadcrumb: " / customers / onboarding pharmacy",
    },

    {
      path: "/customers/onboarding-pharmacy/view/:id",
      breadcrumb: subscribeReqData?.code
        ? ` / ${subscribeReqData?.code} - view`
        : " / view",
    },
  ];

  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });

  const getStatusColor = (status) => {
    if (status === "pending") {
      return "text-warning";
    } else if (status === "rejected") {
      return "text-danger";
    }
    return orderStatus?.find((e) => e?.status === status)?.color;
  };

  return (
    <>
      <div className="products-page">
        <div className="products-main-div">
          {breadcrumbs.map(({ match, breadcrumb }) => (
            <NavLink
              key={match.pathname}
              to={match.pathname}
              className="header-route-page fw_400 cursor_pointer"
            >
              <span className="fs_18">{breadcrumb}</span>
            </NavLink>
          ))}
          <div className="products-main-list my-2 py-1">
            <div className="search-container d-flex justify-content-between align-items-center">
              <div
                className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
                onClick={() => navigate(-1)}
              >
                <img src={back} alt="back_btn" />
                <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                  BACK
                </span>
              </div>
              <div className=" d-flex justify-content-between m-1 mb-2">
                <AdminButton
                  background="#2AD3E7"
                  color="white"
                  width="100px"
                  onClick={() => setApproveShow(true)}
                >
                  UPDATE
                </AdminButton>
              </div>
            </div>
            <div style={{ position: "relative" }}>
              {loading == true ? (
                <div className="list-spinner-container">
                  <LoadingSpinnerTable />
                </div>
              ) : (
                <div className="main-view-page">
                  <div className="mb-4">
                    <div className="d-flex text-left px-3 my-3 py-1 form-sub-details fw_600">
                      Basic Details
                    </div>
                    <div className="product-details-container ms-2 ps-1">
                      <div className="pt-3 row ">
                        {userType == "doctor" ? (
                          <>
                            {docBasicDetails.map((item, index) => (
                              <div
                                key={index}
                                className="mb-2 col-10 col-sm-6 col-md-4 col-xxl-1 me-4 px-2 customers-basic-heading-container"
                              >
                                <h5 className="color_b0b3c7 text-nowrap fs_14 fw_500 m-0">
                                  {item.heading}
                                </h5>
                                <p className={`fs_15 fn_Nunito fw_500`}>
                                  {item.title}
                                </p>
                              </div>
                            ))}
                          </>
                        ) : (
                          <>
                            {pharmacyBasicDetails.map((item, index) => (
                              <div
                                key={index}
                                className="mb-2 col-10 col-sm-6 col-md-4 col-xxl-1 me-4 px-2 customers-basic-heading-container"
                              >
                                <h5 className="color_b0b3c7 text-nowrap fs_14 fw_500 m-0">
                                  {item.heading}
                                </h5>
                                <p className={`fs_15 fn_Nunito fw_500`}>
                                  {item.title}
                                </p>
                              </div>
                            ))}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="mb-4">
                    <div className="d-flex text-left px-3 my-3 py-1 form-sub-details fw_600">
                      Contact Details
                    </div>
                    <div className="product-details-container ms-2 ps-1">
                      <div className="pt-3 row row-cols-6">
                        {contactDetails.map((item, index) => (
                          <div className="mb-2 mb-2 col-10 col-sm-6 col-md-4 col-xxl-2 mx-0  customers-heading-container">
                            <h5 className="color_b0b3c7 text-nowrap fs_14 fw_500 m-0">
                              {item.heading}
                            </h5>
                            <p className={`fs_15 fn_Nunito fw_500`}>
                              {item.title}
                            </p>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <>
                    <>
                      <div className="basic-details-container my-3 mt-4 my-auto d-flex align-items-center ">
                        <label className="basic-title mx-2 mb-1">
                          Documents
                        </label>
                      </div>
                      <div className="row">
                        <div className="col-xxl-4 col-6">
                          <div className="mx-0 px-3">
                            <div className="my-2">
                              <div className="upload-image-label-container d-flex justify-content-between">
                                <label className="my-1 Neutral_Color">
                                  Drug License Certificate - 20A
                                </label>
                              </div>
                              <div
                                className={`h-100`}
                                style={{
                                  height: "25rem",
                                  overflowY: "auto",
                                  overflowX: "hidden",
                                  scrollBehavior: "smooth",
                                  position: "relative",
                                }}
                              >
                                {pdfChecker(
                                  subscribeReqData?.drug_licence_certificate_20_a
                                ) ? (
                                  <div className="manufacturer-doc-upload-container">
                                    <iframe
                                      src={`${subscribeReqData?.drug_licence_certificate_20_a}#toolbar=0`}
                                      className="pdf-view-doc"
                                    />
                                  </div>
                                ) : (
                                  <div
                                    className="manufacturer-doc-upload-container"
                                    style={{ position: "relative" }}
                                  >
                                    <img
                                      className="image-upload"
                                      src={
                                        subscribeReqData?.drug_licence_certificate_20_a
                                      }
                                      alt="Uploaded document"
                                    />
                                  </div>
                                )}
                                <div
                                  className="w-100"
                                  style={{
                                    position: "absolute",
                                    zIndex: "55",
                                    top: "0",
                                    maxWidth: "450px",
                                  }}
                                >
                                  <div
                                    className="manufacturer-doc-upload-container"
                                    style={{
                                      backgroundColor: "rgb(38, 44, 61, 0.5)",
                                    }}
                                  >
                                    <div
                                      className="align-items-center"
                                      style={{
                                        position: "absolute",
                                        zIndex: "55",
                                        top: "43%",
                                        left: "40%",
                                      }}
                                    >
                                      <img
                                        src={eye}
                                        className="mb-2"
                                        alt="Eye icon"
                                      />
                                      {pdfChecker(
                                        subscribeReqData?.drug_licence_certificate_20_a
                                      ) ? (
                                        <button
                                          className="fs_16 fw_600"
                                          style={{
                                            backgroundColor: "transparent",
                                            color: "#E7E5FF",
                                            border: "none",
                                          }}
                                          onClick={() => {
                                            setOpenPdf(true);
                                            setPdfFileUrl(
                                              subscribeReqData?.drug_licence_certificate_20_a
                                            );
                                            setFileName(
                                              "Drug License Certificate 20A"
                                            );
                                          }}
                                        >
                                          VIEW
                                        </button>
                                      ) : (
                                        <button
                                          className="fs_16 fw_600"
                                          style={{
                                            backgroundColor: "transparent",
                                            color: "#E7E5FF",
                                            border: "none",
                                          }}
                                          onClick={() => {
                                            setImageModal(true);
                                            setImageUrlData(
                                              subscribeReqData?.drug_licence_certificate_20_a
                                            );
                                            setFileName(
                                              "Drug License Certificate 20A"
                                            );
                                          }}
                                        >
                                          VIEW
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-xxl-4 col-6">
                          <div className="mx-0 px-3">
                            <div className="my-2">
                              <div className="upload-image-label-container d-flex justify-content-between">
                                <label className="my-1 Neutral_Color">
                                  Drug License Certificate - 20B
                                </label>
                              </div>
                              <div
                                className={` h-100`}
                                style={{
                                  height: "25rem",
                                  overflowY: "auto",
                                  overflowX: "hidden",
                                  scrollBehavior: "smooth",
                                  position: "relative",
                                }}
                              >
                                {pdfChecker(
                                  subscribeReqData?.drug_licence_certificate_20_b
                                ) ? (
                                  <div className="manufacturer-doc-upload-container">
                                    <iframe
                                      src={`${subscribeReqData?.drug_licence_certificate_20_b}#toolbar=0`}
                                      className="pdf-view-doc"
                                    />
                                  </div>
                                ) : (
                                  <div
                                    className="manufacturer-doc-upload-container"
                                    style={{ position: "relative" }}
                                  >
                                    <img
                                      className="image-upload"
                                      src={
                                        subscribeReqData?.drug_licence_certificate_20_b
                                      }
                                    />
                                  </div>
                                )}
                                <div
                                  className="w-100"
                                  style={{
                                    position: "absolute",
                                    zIndex: "55",
                                    top: "0",
                                    maxWidth: "450px",
                                  }}
                                >
                                  <div
                                    className="manufacturer-doc-upload-container"
                                    style={{
                                      backgroundColor: "rgb(38, 44, 61, 0.5)",
                                    }}
                                  >
                                    <div
                                      className="align-items-center"
                                      style={{
                                        position: "absolute",
                                        zIndex: "55",
                                        top: "43%",
                                        left: "40%",
                                      }}
                                    >
                                      <img src={eye} className="mb-2" />
                                      {pdfChecker(
                                        subscribeReqData?.drug_licence_certificate_20_b
                                      ) ? (
                                        <button
                                          className="fs_16 fw_600"
                                          style={{
                                            backgroundColor: "transparent",
                                            color: "#E7E5FF",
                                            border: "none",
                                          }}
                                          onClick={() => {
                                            setOpenPdf(true);
                                            setPdfFileUrl(
                                              subscribeReqData?.drug_licence_certificate_20_b
                                            );
                                            setFileName(
                                              "Drug License Certificate 20B"
                                            );
                                          }}
                                        >
                                          VIEW
                                        </button>
                                      ) : (
                                        <button
                                          className="fs_16 fw_600"
                                          style={{
                                            backgroundColor: "transparent",
                                            color: "#E7E5FF",
                                            border: "none",
                                          }}
                                          onClick={() => {
                                            setImageModal(true);
                                            setImageUrlData(
                                              subscribeReqData?.drug_licence_certificate_20_b
                                            );
                                            setFileName(
                                              "Drug License Certificate 20B"
                                            );
                                          }}
                                        >
                                          VIEW
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {subscribeReqData?.gst_certificate && (
                          <div className="col-xxl-4 col-6">
                            <div className="mx-0 px-3">
                              <div className="my-2">
                                <div className="upload-image-label-container d-flex justify-content-between">
                                  <label className="my-1 Neutral_Color">
                                    GST Certificate
                                  </label>
                                </div>
                                <div
                                  className={` h-100`}
                                  style={{
                                    height: "25rem",
                                    overflowY: "auto",
                                    overflowX: "hidden",
                                    scrollBehavior: "smooth",
                                    position: "relative",
                                  }}
                                >
                                  {pdfChecker(
                                    subscribeReqData?.gst_certificate
                                  ) ? (
                                    <div className="manufacturer-doc-upload-container">
                                      <iframe
                                        src={`${subscribeReqData?.gst_certificate}#toolbar=0`}
                                        className="pdf-view-doc"
                                      />
                                    </div>
                                  ) : (
                                    <div
                                      className="manufacturer-doc-upload-container"
                                      style={{ position: "relative" }}
                                    >
                                      <img
                                        className="image-upload"
                                        src={subscribeReqData?.gst_certificate}
                                      />
                                    </div>
                                  )}
                                  <div
                                    className="w-100"
                                    style={{
                                      position: "absolute",
                                      zIndex: "55",
                                      top: "0",
                                      maxWidth: "450px",
                                    }}
                                  >
                                    <div
                                      className="manufacturer-doc-upload-container"
                                      style={{
                                        backgroundColor: "rgb(38, 44, 61, 0.5)",
                                      }}
                                    >
                                      <div
                                        className="align-items-center"
                                        style={{
                                          position: "absolute",
                                          zIndex: "55",
                                          top: "43%",
                                          left: "40%",
                                        }}
                                      >
                                        <img src={eye} className="mb-2" />
                                        {pdfChecker(
                                          subscribeReqData?.gst_certificate
                                        ) ? (
                                          <button
                                            className="fs_16 fw_600"
                                            style={{
                                              backgroundColor: "transparent",
                                              color: "#E7E5FF",
                                              border: "none",
                                            }}
                                            onClick={() => {
                                              setOpenPdf(true);
                                              setPdfFileUrl(
                                                subscribeReqData?.gst_certificate
                                              );
                                              setFileName("GST Certificate");
                                            }}
                                          >
                                            VIEW
                                          </button>
                                        ) : (
                                          <button
                                            className="fs_16 fw_600"
                                            style={{
                                              backgroundColor: "transparent",
                                              color: "#E7E5FF",
                                              border: "none",
                                            }}
                                            onClick={() => {
                                              setImageModal(true);
                                              setImageUrlData(
                                                subscribeReqData?.gst_certificate
                                              );
                                              setFileName("GST Certificate");
                                            }}
                                          >
                                            VIEW
                                          </button>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                      <div>
                        <div className="basic-details-container my-3 mt-4  my-auto d-flex align-items-center ">
                          <label className="basic-title mx-2 mb-1">
                            Onboarding Photos
                          </label>
                        </div>
                        <div className="row">
                          <div className="col-xxl-4 col-6 ">
                            <div className="mx-0 px-3">
                              <div className="my-2">
                                <div className="upload-image-label-container d-flex justify-content-between">
                                  <label className="my-1 Neutral_Color">
                                    Pharmacy
                                  </label>
                                </div>

                                <div
                                  className="manufacturer-doc-upload-container"
                                  style={{ position: "relative" }}
                                >
                                  <img
                                    className="image-upload"
                                    src={subscribeReqData?.pharmacy_photo}
                                  />
                                  <div
                                    className="w-100"
                                    style={{
                                      position: "absolute",
                                      zIndex: "55",
                                      top: "0",
                                      maxWidth: "450px",
                                    }}
                                  >
                                    <div
                                      className="manufacturer-doc-upload-container"
                                      style={{
                                        backgroundColor:
                                          "rgb(38, 44, 61, 0.6 )",
                                      }}
                                    >
                                      <div
                                        className="align-items-center px-2 mx-2 my-2"
                                        style={{
                                          position: "absolute",
                                          zIndex: "55",
                                          backgroundColor: "#fff",
                                          borderRadius: "5px",
                                        }}
                                      >
                                        <span className="fs_11 Medium_Purple fw_500">
                                          {subscribeReqData?.pharmacy_photo_lat}{" "}
                                          ,
                                          <span className="ms-1">
                                            {
                                              subscribeReqData?.pharmacy_photo_long
                                            }
                                          </span>
                                        </span>
                                      </div>
                                      <div
                                        className="align-items-center"
                                        style={{
                                          position: "absolute",
                                          zIndex: "55",
                                          top: "43%",
                                          left: "40%",
                                        }}
                                      >
                                        <img src={eye} className="mb-2" />
                                        <button
                                          className="fs_16 fw_600"
                                          style={{
                                            backgroundColor: "transparent",
                                            color: "#E7E5FF",
                                            border: "none",
                                          }}
                                          onClick={() => {
                                            setImageModal(true);
                                            setImageTitleData("Pharmacy");
                                            setImageUrlData(
                                              subscribeReqData?.pharmacy_photo
                                            );
                                          }}
                                        >
                                          VIEW
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-xxl-4 col-6 ">
                            <div className="mx-0 px-3">
                              <div className="my-2">
                                <div className="upload-image-label-container d-flex justify-content-between">
                                  <label className="my-1 Neutral_Color">
                                    Photo of Pharmacy’s Nameboard
                                  </label>
                                </div>

                                <div
                                  className="manufacturer-doc-upload-container"
                                  style={{ position: "relative" }}
                                >
                                  <img
                                    className="image-upload"
                                    src={
                                      subscribeReqData?.pharmacy_nameboard_photo
                                    }
                                  />
                                  <div
                                    className="w-100"
                                    style={{
                                      position: "absolute",
                                      zIndex: "55",
                                      top: "0",
                                      maxWidth: "450px",
                                    }}
                                  >
                                    <div
                                      className="manufacturer-doc-upload-container"
                                      style={{
                                        backgroundColor:
                                          "rgb(38, 44, 61, 0.6 )",
                                      }}
                                    >
                                      <div
                                        className="align-items-center px-2 mx-2 my-2"
                                        style={{
                                          position: "absolute",
                                          zIndex: "55",
                                          backgroundColor: "#fff",
                                          borderRadius: "5px",
                                        }}
                                      >
                                        <span className="fs_11 Medium_Purple fw_500">
                                          {
                                            subscribeReqData?.pharmacy_nameboard_lat
                                          }{" "}
                                          ,
                                          <span className="ms-1">
                                            {
                                              subscribeReqData?.pharmacy_nameboard_long
                                            }
                                          </span>
                                        </span>
                                      </div>
                                      <div
                                        className="align-items-center"
                                        style={{
                                          position: "absolute",
                                          zIndex: "55",
                                          top: "43%",
                                          left: "40%",
                                        }}
                                      >
                                        <img src={eye} className="mb-2" />
                                        <button
                                          className="fs_16 fw_600"
                                          style={{
                                            backgroundColor: "transparent",
                                            color: "#E7E5FF",
                                            border: "none",
                                          }}
                                          onClick={() => {
                                            setImageModal(true);
                                            setImageTitleData(
                                              "Photo of Pharmacy’s Nameboard"
                                            );
                                            setImageUrlData(
                                              subscribeReqData?.pharmacy_nameboard_photo
                                            );
                                          }}
                                        >
                                          VIEW
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  </>
                </div>
              )}
            </div>
          </div>
          <div className="products-main-list my-2 py-1 px-4 py-3">
            <div className="d-flex text-left px-3 my-3 py-1 form-sub-details fw_600">
              Approvals
            </div>
            <p className="color_b0b3c7 text-nowrap fs_14 fw_500 mt-4 mx-2">
              Approval History
            </p>
            <div className="modal-table-container w-50">
              <TableContainer>
                <thead>
                  <tr className="table-rows color_747f9e">
                    <th className="table-heads " width={"2%"}>
                      #
                    </th>
                    <th className="table-heads " width={"5%"}>
                      FFID
                    </th>
                    <th className="table-heads " width={"8%"}>
                      Name
                    </th>
                    <th className="table-heads " width={"6%"}>
                      Status
                    </th>
                    <th className="table-heads " width={"10%"}>
                      Date & Time
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {subscribeReqData?.approvalUsers?.map((item, index) => (
                    <tr className="table-rows1" key={index}>
                      <td className="table-each-row-data" width={"2%"}>
                        {index + 1}
                      </td>
                      <td className="table-each-row-data">{"--"}</td>
                      <td className="table-each-row-data">
                        {item.fieldForceUser?.name ?? "--"}
                      </td>
                      <td className="table-each-row-data">
                        <span
                          className={`${getStatusColor(
                            item.approval
                          )} text-capitalize`}
                        >
                          {item.approval}
                        </span>
                      </td>
                      <td className="table-each-row-data">
                        {moment(item?.updatedAt).format("DD MMM YYYY, HH:mm A")}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </TableContainer>
            </div>
          </div>

          <UpdateToExecutiveModal
            divisiondata={fullDataShow}
            data={subscribeReqData}
            show={approveShow}
            ShowClose={() => setApproveShow(false)}
          />
          <ErrorPopup
            show={showErrorPopup}
            title={showErrorMsg}
            handleClose={closeErrorPopup}
          />
          <ImageViewModal
            show={imageModal}
            ShowClose={() => setImageModal(false)}
            imageTitleData={imageTitleData}
            imageUrlData={imageUrlData}
          />
          <PdfView
            show={openPdf}
            handleClose={() => setOpenPdf(false)}
            pdfUrl={pdfFileUrl}
            filename={filename}
          />
        </div>
      </div>
    </>
  );
};

export default SubscribeRequestPharmacyView;

export const orderStatus = [
  { status: "acknowledged", value: "Acknowledged", color: "ack_status" },
  {
    status: "partially_acknowledged",
    value: "Partially Acknowledged",
    color: "color_2ad3e7 ",
  },
  { status: "fully_invoiced", value: "Fully Invoiced", color: "text_green" },
  {
    status: "partially_invoiced",
    value: "Partial Invoiced",
    color: "Medium_Purple",
  },
  { status: "pending", value: "Approval Pending", color: "Medium_Purple" },
  { status: "expired", value: "Expired", color: "text-danger" },
  { status: "cancelled", value: "Cancelled", color: "text-danger" },
  { status: "approval_failed", value: "Approval Failed", color: "text-danger" },
  { status: "approved", value: "Approved", color: "color_2ad3e7" },
  { status: "rejected", value: "Rejected", color: "text-danger" },
  { status: "hold", value: "Under Process", color: "text-warning" },
];
